"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFCP = exports.FCPThresholds = void 0;

var _bindReporter = require("./lib/bindReporter.js");

var _getActivationStart = require("./lib/getActivationStart.js");

var _getVisibilityWatcher = require("./lib/getVisibilityWatcher.js");

var _initMetric = require("./lib/initMetric.js");

var _observe = require("./lib/observe.js");

var _whenActivated = require("./lib/whenActivated.js");

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */
const FCPThresholds = exports.FCPThresholds = [1800, 3000];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */

const onFCP = (onReport, opts = {}) => {
  (0, _whenActivated.whenActivated)(() => {
    const visibilityWatcher = (0, _getVisibilityWatcher.getVisibilityWatcher)();
    const metric = (0, _initMetric.initMetric)('FCP');
    let report;

    const handleEntries = entries => {
      entries.forEach(entry => {
        if (entry.name === 'first-contentful-paint') {
          po.disconnect(); // Only report if the page wasn't hidden prior to the first paint.

          if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            // The activationStart reference is used because FCP should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the FCP, this time should be clamped at 0.
            metric.value = Math.max(entry.startTime - (0, _getActivationStart.getActivationStart)(), 0);
            metric.entries.push(entry);
            report(true);
          }
        }
      });
    };

    const po = (0, _observe.observe)('paint', handleEntries);

    if (po) {
      report = (0, _bindReporter.bindReporter)(onReport, metric, FCPThresholds, opts.reportAllChanges);
    }
  });
};

exports.onFCP = onFCP;